<template>
  <el-form ref="baseForm" :rules="rules" :model="fromData">
    <search-box @subSearch="subSearch" :fromData="fromData">
      <el-form-item class="item" label="物料：" prop="materialCode">
        <el-input
         clearable
          v-model="fromData.searchCriteria.codeOrDesc"
          :placeholder="$store.state.remark.matter"
        ></el-input>
      </el-form-item>
      <el-form-item class="item" label="物料类型：" prop="materialType">
        <el-select
          v-model="fromData.searchCriteria.materialTypeId"
          @change="getMaterialType"
          clearable
          filterable
          :placeholder="$store.state.remark.matterType"
        >
          <el-option
            v-for="item in MaterialType"
            :key="item.materialTypeId"
            :label="item.materialTypeDesc"
            :value="item.materialTypeId"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="item" label="物料组：" prop="materialGroup">
        <el-select
          v-model="fromData.searchCriteria.materialGroupId"
          @change="getMaterialGroup"
          filterable
          clearable
          :placeholder="$store.state.remark.matterGroup"
        >
          <el-option
            v-for="item in MaterialGroup"
            :key="item.materialGroupId"
            :label="item.materialGroupDesc"
            :value="item.materialGroupId"
          ></el-option>
        </el-select>
      </el-form-item>
    </search-box>
  </el-form>
</template>

<script>
import searchBox from "components/common/search.vue";
export default {
  components: {
    searchBox
  },
  props: {
    fromData: Object,
    MaterialType: Array,
    MaterialGroup: Array
  },
  data() {
    return {
      rules: {
        materialCode: [{ message: "", trigger: "blur" }],
        materialType: [{ message: "", trigger: "change" }],
        materialGroup: [{ message: "", trigger: "change" }]
      }
    };
  },
  methods: {
    //搜索
    subSearch() {
      this.$emit("subSearch");
    },
    getMaterialGroup(val) {
      this.fromData.searchCriteria.materialGroupId = val;
      console.log(this)
      /* let obj = this.MaterialGroup.find(v=>v.materialGroupDesc === val);
      if(obj){
        this.fromData.searchCriteria.materialGroupId = obj.materialGroupId;
      } */
    },
    getMaterialType(val) {
      console.log(val);
      this.fromData.searchCriteria.materialTypeId = val;
    },
    //清除物料类型
    // clearMaterType() {
    //   this.fromData.searchCriteria.materialTypeId = "";
    //   this.MaterialType = "";
    // }
  }
};
</script>

<style>
</style>
